/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Table, message, Modal, Tag, Space, Button, Input } from 'antd';
import { Link } from 'react-router-dom';
import { roleService } from '../../../services/userService';
import { itemRender } from '../../../components/Pagination';
import { searchnormal, plusicon, editicon, deleteicon } from '../../../components/imagepath';
import Breadcrumb from '../../../components/ui/Breadcrumb';

const { Search } = Input;

const RoleList = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);

  const fetchRoles = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const response = await roleService.getAll({
        page,
        per_page: pagination.pageSize,
        search: searchTerm || undefined,
      });
      setRoles((response.data || []).map(r => ({
        key: r.id,
        id: r.id,
        name: r.name,
        description: r.description,
        userCount: r.users?.length || 0,
      })));
      setTotal(response.total || 0);
    } catch (error) {
      console.error('Error fetching roles:', error);
      message.error('Error al cargar roles');
    } finally {
      setLoading(false);
    }
  }, [searchTerm, pagination.pageSize]);

  useEffect(() => {
    fetchRoles(pagination.current);
  }, [fetchRoles, pagination.current]);

  const handleTableChange = (pag) => {
    setPagination(pag);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setPagination({ ...pagination, current: 1 });
  };

  const handleDelete = async () => {
    if (!roleToDelete) return;
    try {
      await roleService.delete(roleToDelete.id);
      message.success('Rol eliminado correctamente');
      setDeleteModalVisible(false);
      setRoleToDelete(null);
      fetchRoles(pagination.current);
    } catch (error) {
      message.error('Error al eliminar rol');
    }
  };

  const showDeleteModal = (role) => {
    setRoleToDelete(role);
    setDeleteModalVisible(true);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Usuarios',
      dataIndex: 'userCount',
      key: 'userCount',
      render: (count) => <Tag color="blue">{count}</Tag>,
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/roles/${record.id}/edit`}>
            <img src={editicon} alt="Editar" />
          </Link>
          <Button
            type="link"
            onClick={() => showDeleteModal(record)}
            style={{ padding: 0 }}
          >
            <img src={deleteicon} alt="Eliminar" />
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Roles</h3>
                <Breadcrumb items={[{ label: 'Inicio', to: '/admin-dashboard' }, { label: 'Roles' }]} />
              </div>
            </div>
          </div>

          {/* Search and Add Row */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="row">
                  <div className="col-xl-4">
                    <div className="form-group">
                      <Search
                        placeholder="Buscar roles..."
                        onSearch={handleSearch}
                        enterButton={<img src={searchnormal} alt="search" />}
                      />
                    </div>
                  </div>
                  <div className="col-xl-8">
                    <div className="form-group text-end">
                      <Link to="/roles/new" className="btn btn-primary btn-lg">
                        <img src={plusicon} alt="plus" /> Nuevo Rol
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={roles}
                      loading={loading}
                      pagination={{
                        ...pagination,
                        total: total,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} roles`,
                        itemRender: itemRender,
                      }}
                      onChange={handleTableChange}
                      rowKey="key"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Confirmar eliminación"
        open={deleteModalVisible}
        onOk={handleDelete}
        onCancel={() => setDeleteModalVisible(false)}
        okText="Eliminar"
        okButtonProps={{ danger: true }}
      >
        <p>¿Está seguro que desea eliminar el rol <strong>{roleToDelete?.name}</strong>?</p>
        <p>Esta acción no se puede deshacer.</p>
      </Modal>
    </>
  );
};

export default RoleList;
